module.exports = "/next-static/_next/static/images/block_image_be_everywhere-9b43268c684c62e5922a3d92cfb847b9.webp";